import React, { useEffect, forwardRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import AccessGroupList from '../AccessGroupList/AccessGroupList'

const ModalContainer = forwardRef(
  (
    {
      accessGroups,
      fetchAccessGroups,
      isEditing,
      maxListHeight,
      scrollbarsHeight,
      onModalSubmit = () => {},
    },
    ref,
  ) => {
    const onSubmit = (addAccessGroups, deleteAccessGroups) => {
      onModalSubmit(addAccessGroups)
    }

    useEffect(() => {
      fetchAccessGroups()
    }, [])

    return (
      <div>
        <AccessGroupList
          ref={ref}
          displayedList={[]}
          dropdownList={accessGroups}
          isEditing={isEditing}
          isLoading={false}
          maxListHeight={maxListHeight}
          scrollbarsHeight={scrollbarsHeight}
          onSubmit={(addAccessGroups, deleteAccessGroups) => {
            onSubmit(addAccessGroups, deleteAccessGroups)
          }}
        />
      </div>
    )
  },
)

function mapDispatchToProps(dispatch) {
  return {
    fetchAccessGroups: () =>
      dispatch(OperatorUserActions.fetchAccessGroupsList()),
  }
}

const mapStateToProps = (state) => ({
  accessGroups: OperatorUserSelectors.getAccessGroupsList(state),
})

ModalContainer.propTypes = {
  accessGroups: PropTypes.arrayOf(PropTypes.object),
  isEditing: PropTypes.bool,
  fetchAccessGroups: PropTypes.func,
  maxListHeight: PropTypes.number,
  scrollbarsHeight: PropTypes.string,
  onModalSubmit: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ModalContainer)
